// src/index.ts
import * as React from "react";
import debounce from "lodash/debounce";
import { breakpointDesktop } from "@airhelp/design-tokens";

// ../../consts.ts
var RESIZE_DEBOUNCE_TIME = 200;

// src/index.ts
var getWindowWidth = () => {
  if (typeof window !== "undefined") {
    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
  }
  return 0;
};
function useMobileDetect() {
  const desktopWidth = parseInt(breakpointDesktop, 10);
  const [isMobile, setIsMobile] = React.useState(
    typeof window !== "undefined" ? window.innerWidth < desktopWidth : false
  );
  const handleSizeChange = () => debounce(() => {
    const width = getWindowWidth();
    setIsMobile(width < desktopWidth);
  }, RESIZE_DEBOUNCE_TIME)();
  React.useEffect(() => {
    if (typeof window !== "undefined") {
      handleSizeChange();
      window.addEventListener("resize", handleSizeChange);
      return () => {
        window.removeEventListener("resize", handleSizeChange);
      };
    }
  }, [isMobile]);
  return isMobile;
}
export {
  getWindowWidth,
  useMobileDetect
};
